import { Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

function Spin() {
  return (
    <>
      <Spinner animation="border" variant="primary" />
    </>
  );
}

export default Spin;
